// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__BdaUe"};